import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_OR_CREATE_ANAMNESIS_REQUEST =
    NS + 'FIND_OR_CREATE_ANAMNESIS_REQUEST'
export const FIND_OR_CREATE_ANAMNESIS_SUCCESS =
    NS + 'FIND_OR_CREATE_ANAMNESIS_SUCCESS'
export const FIND_OR_CREATE_ANAMNESIS_ERROR =
    NS + 'FIND_OR_CREATE_ANAMNESIS_ERROR'

export const CHANGE_ANAMNESIS = NS + 'CHANGE_ANAMNESIS'
export const UPDATE_ANAMNESIS = NS + 'UPDATE_ANAMNESIS'
export const TOGGLE_ANAMNESIS = NS + 'TOGGLE_ANAMNESIS'
export const TOGGLE_EDITING_TREATMENT_EXPECTATION =
    NS + 'TOGGLE_EDITING_TREATMENT_EXPECTATION'
export const TOGGLE_INFO_LEGEND = NS + 'TOGGLE_INFO_LEGEND'
export const SAVE_ANAMNESIS_REQUEST = NS + 'SAVE_ANAMNESIS_REQUEST'
export const SAVE_ANAMNESIS_SUCCESS = NS + 'SAVE_ANAMNESIS_SUCCESS'
export const SAVE_ANAMNESIS_ERROR = NS + 'SAVE_ANAMNESIS_ERROR'



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/type.js